import { SlideComponent } from '@/types/slide';

/**
 * The Creator class declares the factory method that is supposed to return an
 * object of a SlideComponent. The Creator's subclasses provide the implementation
 * of this method.
 */
export abstract class SlideComponentCreator {
    public abstract create(id: string): SlideComponent;
}

export function CreateSlideComponent(creator: SlideComponentCreator, id: string): SlideComponent {
    return creator.create(id);
}
